import './index.scss';
import ModalManager from 'utils/modal_manager';
import rules from 'utils/permissions/rules';

function openModal() {
  if (!rules.confirmed_account()) {
    ModalManager.open('#js-account-not-confirm-modal');
    return;
  }

  ModalManager.open('#js-practice-test-redirect-board-modal');
}

$('.js-practice-test-redirect-board').on('click', () => openModal());

if (window.location.hash === '#criar-simulado') {
  setTimeout(() => openModal(), 500);
}
